
    (window.__NEXT_P = window.__NEXT_P || []).push([
      "/[region]/[resort]/skidort",
      function () {
        return require("private-next-pages/[region]/[resort]/skidort.tsx");
      }
    ]);
    if(module.hot) {
      module.hot.dispose(function () {
        window.__NEXT_P.push(["/[region]/[resort]/skidort"])
      });
    }
  